import React, { useState, useLayoutEffect } from "react";
import { RouteComponentProps } from "react-router";
import LogIn from "./LogIn/LogIn";
import { Grid, Paper } from "@material-ui/core";
import { MobXProviderContext } from "mobx-react";
import useStyles, { STGrid } from "./styles";
import { ThemeProvider } from "styled-components";

function useStores() {
  return React.useContext(MobXProviderContext);
}

const CompleteAccountLinkAuthorization = (props: RouteComponentProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const { values, themes } = useStores();
  const classes = useStyles({});

  useLayoutEffect(() => {
    async function componentDidMount() {
      await themes.getCurrentTheme(values.themeTypes.Login);

      setIsLoading(false);
    }
    if (isLoading) {
      componentDidMount();
    }
  }, []);

  if (isLoading) {
    return null;
  }
  return (
    <ThemeProvider theme={themes.login}>
      <STGrid
        id="login-page"
        container
        justify="center"
        direction="column"
        alignItems="center"
        className={classes.loginGrid}
        loginbackgroundlandscapeimageurl={themes.login.loginBackgroundLandscapeImageUrl}
        loginbackgroundportraitimageurl={themes.login.loginBackgroundPortraitImageUrl}
        styles={themes.login.css}
      >
        <img id="login-page-logo" className={classes.loginLogo} src={themes.login.loginLogoImageUrl} />
        <Paper elevation={2} className={classes.paperRoot} id="login-form">
          <Grid item>
            <LogIn {...props} />
          </Grid>
        </Paper>
      </STGrid>
    </ThemeProvider>
  );
};

export default CompleteAccountLinkAuthorization;
